const { randomString } = require('./random-string')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @returns {string}
 */
function buildName (name) {
  return `zmarta_${name}_${randomString(10)}`
}

module.exports = { buildName }
